import styled from "styled-components";

export const ChatBubble = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  position: relative;

  &.inbound {
    align-self: flex-start;
    padding-right: 50px;
    background-color: ${({ theme }) => theme.colors.redesign.db10};
    border-radius: 16px 16px 16px 4px;

    p {
      color: ${({ theme }) => theme.colors.redesign.db100};
    }
  }

  &.outbound {
    align-self: flex-end;
    background-color: ${({ theme }) => theme.colors.redesign.b100};

    border-radius: 16px 16px 4px 16px;

    p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
